import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";

const getCityNameForHeroName = (AccountDetailData, selectedheroname) => {
  let retObj = null;
  AccountDetailData.heroes.forEach((city) => {
    city.cityheroes.map((hero) => {
      const { heroname } = hero;
      if (heroname === selectedheroname) {
        retObj = city.cityname;
      }
    });
  });
  return retObj;
};

const getCityForCityName = (AccountDetailData, cityname) => {
  let retObj = null;
  AccountDetailData.heroes.forEach((city) => {
    if (city.cityname === cityname) {
      retObj = city;
    }
  });
  return retObj;
};

export default function(props) {
  const { label, AccountDetailData, taskConfig, setValue, param } = props;
  const paramValue = taskConfig[param];
  const [selectedcity, setSelectedcity] = React.useState(
    getCityNameForHeroName(AccountDetailData, paramValue)
  );
  let selectedCityDetail = getCityForCityName(AccountDetailData, selectedcity);

  const options = AccountDetailData.heroes.map((city) => {
    //logger.log(city);
    const { cityname } = city;
    return { label: cityname, value: cityname };
  });

  const herooptions =
    (selectedCityDetail &&
      selectedCityDetail.cityheroes.map((hero) => {
        logger.log(hero);
        const { heroname } = hero;
        return { label: heroname, value: heroname };
      })) ||
    [];

  logger.log("paramValue", paramValue, taskConfig[param]);

  return (
    <>
      <div>
        <span
          style={{ float: "left", marginBottom: "10px", marginTop: "10px" }}
        >
          {label}
        </span>
      </div>
      <div>
        <AngSelect
          placeholder="Select a city"
          ng-model={selectedcity}
          options={options}
          onChange={(event) => {
            logger.log("event", event);
            const value = event.value;
            setSelectedcity(value);
          }}
        />
      </div>
      <div style={{ paddingTop: "5px" }}>
        <AngSelect
          placeholder="Select a hero"
          required={true}
          ng-model={paramValue}
          disabled={!selectedcity}
          onChange={({ value }) => {
            var selhero = null;
            selectedCityDetail &&
              selectedCityDetail.cityheroes.forEach((hero) => {
                if (hero.heroname === value) {
                  selhero = hero;
                }
              });
            logger.log("selhero", selhero);
            if (selhero && selhero.heroname) {
              setValue({ target: { value: selhero.heroname } }, param);
            }
          }}
          options={herooptions}
        />
      </div>
    </>
  );
}
